'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;



//////////////////
// WEBPACK FOOTER
// ../call-bind-apply-helpers/functionApply.js
// module id = 412
// module chunks = 0